import { useState } from "react";
import { Select } from "antd";
import { Button, Popconfirm } from "../../../../BP2Components";
import PropTypes from "prop-types";
import SettingsModal from "../../../../Modal/SettingsModal";
import MessageModal from "../../Modals/MessageModal";
import IntlMessages from "../../../../../util/IntlMessages";
import { useSelector } from "react-redux";
import "./SingleButton.less";
import { Icon_User } from "../../../../BP2Components/Icons/icons";
import {
   useFastActionsContext,
   useFormState,
} from "../../../../Widgets/InfiniteListWidget/FastActionsContext/FastActionContext";
import { useCheckIfButtonDisabled } from "../../../../../util/useCheckIfButtonDisabled";
import { useMessageItem } from "../../../../../context/MessageItemContext/MessageItemContext";

const { Option } = Select;

const SingleButton = ({
   button,
   handleNormalAction,
   windowWidth,
   instanceId,
   recordId,
   buttonAsLink = false,
   actionId,
   showIconWithStyle,
   btnClassName,
   plannedDate,
   disabled = false,
   insideDropdown,
   currentProcessStep,
   isSingleCaseItem,
   setIsDropdownOpen,
   isButtonClickedFromDropdown,
   linkToCase,
}) => {
   const [recipientId, setRecipientId] = useState(null);
   const [isOpen, setIsOpen] = useState(false);

   const { setActions, setModalStep } = useFastActionsContext();

   const { setIsFormOpen } = useFormState();

   const { setTriggerRequiredFieldsModal } = useMessageItem();

   const { listOfAllUsers } = useSelector(({ messages }) => messages);
   const btnSize = windowWidth > 933 ? "middle" : "small";

   const buttonType = insideDropdown ? "default" : "primary";

   const checkIfDisabled = useCheckIfButtonDisabled();

   const handleFormAction = () => {
      setIsFormOpen(currentProcessStep?.instanceId, true);
      setModalStep(currentProcessStep);

      if (isButtonClickedFromDropdown) {
         setActions([button]);
      } else {
         setActions(
            Array.isArray(currentProcessStep.actions)
               ? currentProcessStep.actions
               : [currentProcessStep.actions],
         );
      }

      if (setIsDropdownOpen) {
         requestAnimationFrame(() => {
            setIsDropdownOpen(false);
         });
      }
   };

   const handleButtonNormalAction = async (event, closeModal, isUserNextStepRecipient) => {
      closeModal && closeModal();
      await handleNormalAction(
         button,
         undefined,
         button.targetStepId,
         recipientId,
         null,
         isUserNextStepRecipient,
      )(event);
   };

   if (isSingleCaseItem) {
      return (
         <>
            <Button
               buttonType={buttonType}
               key={button.label}
               className="normal-buttons__single__action"
               size={btnSize}
               title={button.label}
               onClick={handleFormAction}
               disabled={disabled}
            >
               <span> {button.label}</span>
               {showIconWithStyle && (
                  <i className="material-symbols-outlined arrow-icon">chevron_right</i>
               )}
            </Button>
         </>
      );
   }
   return button.nextStepRecipientHandlingMode.toString() === "0" ||
      button.nextStepRecipientHandlingMode.toString() === "2" ? (
      <div className="normal-buttons__with-list">
         <Button
            buttonType={buttonType}
            disabled={disabled || checkIfDisabled(button, button.recordId)}
            onClick={(event) =>
               handleButtonNormalAction(event, () => {
                  setIsOpen(false);
                  setIsDropdownOpen && setIsDropdownOpen(false);
               })
            }
            key={button.label}
            className={"normal-buttons__with-list__action"}
            size={btnSize}
         >
            {button.label}
            {showIconWithStyle && (
               <span className="material-symbols-outlined arrow-icon">chevron_right</span>
            )}
         </Button>
         {button.nextStepRecipientHandlingMode === "0" && (
            <Popconfirm
               title={
                  <Select
                     onSelect={setRecipientId}
                     showSearch
                     placeholder={<IntlMessages id="modal.selectRecipient" />}
                     filterOption={(input, option) => {
                        return option.props.value !== null && option.props.children !== null
                           ? option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                           : null;
                     }}
                  >
                     {listOfAllUsers?.map((user) => (
                        <Option value={user.id}>{`${user.lastName} ${user.name}`}</Option>
                     ))}
                  </Select>
               }
            >
               <Button
                  buttonType={buttonType}
                  htmlType="button"
                  size={btnSize}
                  disabled={disabled || checkIfDisabled(button, recordId)}
               >
                  <Icon_User />
               </Button>
            </Popconfirm>
         )}
      </div>
   ) : (
      <SettingsModal
         key={button.label}
         isOpen={isOpen}
         setIsOpen={setIsOpen}
         validateBeforeOpen
         customAvatar={
            <div className="normal-buttons__single">
               <Button
                  buttonType="default"
                  disabled={disabled || checkIfDisabled(button, recordId)}
                  key={button.label}
                  onClick={() => setTriggerRequiredFieldsModal(true)}
                  className="normal-buttons__single__action"
                  size={btnSize}
               >
                  {button.label}
               </Button>
            </div>
         }
         children={
            <MessageModal
               action={button}
               handleNormalAction={handleNormalAction}
               closeModal={() => setIsOpen(false)}
               instanceId={instanceId}
               recordId={recordId}
               linkToCase={isSingleCaseItem ? linkToCase : null}
            />
         }
         title={button.label}
      />
   );
};

SingleButton.propTypes = {
   handleNormalAction: PropTypes.func.isRequired,
};

export default SingleButton;
